/* @flow */
import AuthActions from 'auth/AuthActions';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const AdminSignupRedirect = React.createClass({
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      const loggedIn = () => {
        replaceWith('/setup/admin_role');
        callback();
      };
      const notLoggedIn = () => {
        window.location = LinkConstants.SIGN_UP;
        callback();
      };

      AuthActions.checkLoggedIn().then(loggedIn, notLoggedIn);
    },
  },

  render() {
    return null;
  },
});

export default AdminSignupRedirect;



// WEBPACK FOOTER //
// ./src/admin/components/AdminSignupRedirect.jsx